<template>
    <div v-if="lang" class="points-of-interest-list">
        <div
            v-for="(category, label) in poi"
            :key="label"
            class="poi-category"
        >
            <template v-if="Array.isArray(category)">
                <h3>
                    <img :src="'/img/icons/poi/' + label + '.svg'" :alt="label">
                    {{ trans(label) }}
                </h3>

                <div class="poi-category-data" :class="label">
                    <div
                        v-for="(place, index) in category"
                        :key="index"
                        class="row"
                    >
                        <img v-if="['railway', 'bus'].includes(place.class)" :src="'/img/icons/' + place.icon + '.svg'">

                        <div class="col" v-html="place.name ? place.name : trans(label)"></div>

                        <div class="col-auto" v-html="place.distance"></div>
                    </div>
                </div>
            </template>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        poi: {
            type: Object,
            required: true,
        },
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail.points_of_interest
        },
    },
}
</script>